export default __webpack_public_path__ + "static/media/banner2.3bfb5ec2.jpg";